import BookIcon from '@material-ui/icons/Book'
import BusinessShow from './BusinessShow'
import BusinessList from './BusinessList'

export default {
  list: BusinessList,
  show: BusinessShow,
  icon: BookIcon,
}
